import { useFormikContext } from 'formik';

import RadioButton from 'components/shared/RadioButton/RadioButton';

const ExportRadioGroup = ({ label, field, options, qaPrefix, isRequired = false }) => {
  const { values, setFieldValue } = useFormikContext();

  if (!values.export_type.includes('pdf')) return null;

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        {label}
        {isRequired && <span className="text-danger-400">*</span>}
      </label>

      <div className="mt-2 flex gap-4">
        {options.map((option) => (
          <RadioButton
            key={option.value}
            size="medium"
            dataQA={`${qaPrefix}-${option.value}`}
            isSelected={values?.[field] === option.value}
            onChange={() => setFieldValue(field, option.value)}
            label={option.label}
            name={field}
            wrapperClassName="w-max"
          />
        ))}
      </div>
    </div>
  );
};

export default ExportRadioGroup;
